export const SCRIPT_INTEGRITY = 'sha384-APmzAnDgfWsEFxXgwRYD07RFNOyt81eBwUGam2zeaKQk0SxdOT4tzocTLaHd7NgF'
export const WIDGET_SCRIPT_LINK = 'https://widget.metacrm.inc/static/js/widget-1-3-0.js'

export const METACRM_API_KEY = 'qptu0e3a3t'
